/**
 * Turns a setAttribute value into a string Vue/DOM can use.
 * Returns undefined when the value must be skipped (plain objects, host objects
 * without a primitive), so we never throw and never write "[object SVGAnimatedLength]".
 */
export function attrValueFromUnknown(value) {
    if (value == null) return value

    const type = typeof value
    if (type === 'string' || type === 'number' || type === 'boolean') {
        return String(value)
    }
    if (type !== 'object') {
        return String(value)
    }

    if (
        typeof value.default === 'string' ||
        typeof value.default === 'number' ||
        typeof value.default === 'boolean'
    ) {
        return String(value.default)
    }

    if (typeof value.baseVal === 'string' || typeof value.baseVal === 'number') {
        return String(value.baseVal)
    }

    const baseVal = value.baseVal
    if (baseVal && typeof baseVal.valueAsString === 'string') {
        return baseVal.valueAsString
    }
    if (baseVal && typeof baseVal.value === 'number') {
        return String(baseVal.value)
    }

    return undefined
}

export function primitiveBindings(raw) {
    const bindings = {}
    if (!raw || typeof raw !== 'object') return bindings
    Object.keys(raw).forEach(key => {
        const value = raw[key]
        if (value == null || typeof value === 'object') return
        bindings[key] = value
    })
    return bindings
}

export function installSafeSetAttribute() {
    const nativeSetAttribute = Element.prototype.setAttribute
    if (nativeSetAttribute.__epSafe) return

    const patched = function(name, value) {
        if (value != null && typeof value === 'object') {
            const next = attrValueFromUnknown(value)
            if (next === undefined) return
            return nativeSetAttribute.call(this, name, next)
        }
        return nativeSetAttribute.call(this, name, value)
    }
    patched.__epSafe = true
    Element.prototype.setAttribute = patched
}
